// extracted by mini-css-extract-plugin
module.exports = {"performance":"LoadingIndicator_performance__1JANN","rotation":"LoadingIndicator_rotation__1dy3l"};